import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=27855498&scoped=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"
import style0 from "./Text.vue?vue&type=style&index=0&id=27855498&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27855498",
  null
  
)

export default component.exports